export const getComments = state => state.comment.commentList;
export const getCommentDetails = state => state.comment.commentDetails;
export const getPredefinedComments = state => state.comment.predefinedCommentList;
